import { filterEmptyObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/discover-places';

export default {
  async createDiscoverPlace(payload) {
    const response = await axiosClient.post(endPoint, payload);
    return response.data;
  },

  async getDiscoverPlaceList(payload) {
    const response = await axiosClient.get(endPoint, {
      params: filterEmptyObject(payload),
    });
    return response.data;
  },

  async deleteDiscoverPlace(id) {
    const response = await axiosClient.delete(`${endPoint}/${id}`);
    return response.data;
  },

  async getDiscoverPlaceDetails(id) {
    const response = await axiosClient.get(`${endPoint}/${id}`);
    return response.data;
  },

  async updateDiscoverPlace(id, payload) {
    const response = await axiosClient.put(`${endPoint}/${id}`, payload);
    return response.data;
  },

  async updateDiscoverPlaceDiscoverProvince(id, payload) {
    const response = await axiosClient.put(`${endPoint}/${id}/discover-province`, payload);
    return response.data;
  },
};
